var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "duplicate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8667 1.1842V8.65165C10.8667 9.29716 10.3466 9.82657 9.70106 9.83585V3.34828C9.70106 2.1455 8.72119 1.16563 7.51841 1.16563H3.74289C3.75218 0.520121 4.28159 0 4.92709 0H9.68248C10.3373 0 10.8667 0.529409 10.8667 1.1842Z",
    fill: "#002466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70265 3.34835V10.8158C8.70265 11.4706 8.17324 12 7.51845 12H2.76306C2.10827 12 1.57886 11.4706 1.57886 10.8158V3.34835C1.57886 2.6982 2.10827 2.16415 2.76306 2.16415H7.51845C8.17324 2.16415 8.70265 2.6982 8.70265 3.34835Z",
    fill: "#002466"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveIcon);
export default __webpack_public_path__ + "static/media/Interactive-icon.2d668cce86ea7491219c47340e82293a.svg";
export { ForwardRef as ReactComponent };